<template>
  <div class="share-obituary-comment" v-if="fbReady">
    <p>{{ description }}</p>

    <div
      class="share-obituary-comment__button-group"
      v-if="isNew || isLandingPage"
    >
      <button
        class="btn icon brand-facebook"
        type="button"
        @click.prevent="shareFacebook"
      >
        <svg aria-hidden="true" class="icon"><use href="#facebook" /></svg>
        {{ texts.shareFacebook }}
      </button>

      <button
        class="btn icon"
        type="button"
        @click.prevent="scrollToShareSection"
      >
        <svg aria-hidden="true" class="icon"><use href="#share" /></svg>
        {{ shareText }}
      </button>
    </div>

    <a
      class="btn obituary share-obituary-comment__gift-link"
      v-if="isNew && guestLink"
      :href="guestLink"
    >
      {{ texts.giftCertificateLink }}
    </a>

    <single-comment
      v-if="isNew || isLandingPage"
      :comment="comment"
      :deceased-name="deceasedName"
      :open-lightbox="openLightbox"
      :preview="true"
    />

    <!-- biome-ignore lint/a11y/useHeadingContent: the heading text comes
    from the v-html span, which also carries the scroll ref and the
    inline-block wrapper the highlight animation scales. -->
    <h3 v-if="isNew || isLandingPage">
      <span ref="shareComment" v-html="shareHeading" />
    </h3>

    <share-comment-links
      :deceased-name="deceasedName"
      :share-link="comment.url"
    />

    <share-comment-edit-content
      v-if="isNew"
      :change-modal-context="changeModalContext"
    />
  </div>
</template>

<script>
  import { sprintf } from "sprintf-js";
  import { mapState } from "vuex";
  import ShareCommentEditContent from "./ShareCommentEditContent.vue";
  import ShareCommentLinks from "./ShareCommentLinks.vue";
  import SingleComment from "./SingleComment.vue";

  export default {
    beforeUnmount() {
      if (this._fbPollInterval) {
        clearInterval(this._fbPollInterval);
      }
    },

    components: {
      ShareCommentEditContent,
      ShareCommentLinks,

      SingleComment,
    },

    computed: {
      ...mapState("donations", ["guestLink"]),

      description() {
        if (this.isNew) {
          return lavendlaObituary.locale === "da_DK"
            ? ""
            : sprintf(this.texts.thanksForYourConcern, this.deceasedName);
        }

        if (this.isLandingPage) {
          return this.texts.shareOrClose;
        }

        return this.texts.shareWithOthers;
      },

      shareHeading() {
        return this.isLandingPage
          ? `${this.texts.shareThisCondolence}:`
          : `${this.texts.shareThisCondolence2}:`;
      },
      shareIsSupported() {
        return !!navigator.share;
      },

      shareText() {
        return this.shareIsSupported
          ? this.texts.shareThisCondolence
          : this.texts.moreWaysToShare;
      },
    },

    data() {
      return {
        fbReady: window.fbState?.init,
        texts: lavendlaObituary.shareCommentContent,
      };
    },

    methods: {
      initFacebookSdk() {
        // load facebook sdk script
        ((d, s, id) => {
          const [fjs] = d.getElementsByTagName(s);
          if (d.getElementById(id)) {
            return;
          }
          const js = d.createElement(s);
          js.id = id;
          js.src = "https://connect.facebook.net/se_SV/sdk.js";
          fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
      },

      scrollToShareSection() {
        this.$refs.shareComment.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });

        this.$refs.shareComment.classList.add("scrolled-to");

        setTimeout(() => {
          this.$refs.shareComment.classList.remove("scrolled-to");
        }, 4000);
      },
      shareFacebook() {
        FB.ui({
          href: this.comment.url,
          method: "share",
        });
      },
    },

    mounted() {
      this.initFacebookSdk();
      if (!this.fbReady) {
        this._fbPollInterval = setInterval(() => {
          if (window.fbState?.init) {
            this.fbReady = true;
            clearInterval(this._fbPollInterval);
          }
        }, 200);
      }
    },
    name: "ShareCommentContent",

    props: {
      changeModalContext: {
        default: null,
        type: Function,
      },
      comment: {
        required: true,
        type: Object,
      },
      deceasedName: {
        required: true,
        type: String,
      },
      isLandingPage: {
        default: false,
        type: Boolean,
      },
      isNew: {
        default: false,
        type: Boolean,
      },
      memorialFund: {
        default: null,
        type: Object,
      },
      openLightbox: {
        default: null,
        type: Function,
      },
    },
  };
</script>
